// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"257":"44db8f00","295":"3facf154","928":"c8436595"}[chunkId] + ".chunk.js";
};